import { render, staticRenderFns } from "./IabfPersonEmailIdentity.vue?vue&type=template&id=6b00f23c&scoped=true"
import script from "./IabfPersonEmailIdentity.vue?vue&type=script&lang=js"
export * from "./IabfPersonEmailIdentity.vue?vue&type=script&lang=js"
import style0 from "./IabfPersonEmailIdentity.vue?vue&type=style&index=0&id=6b00f23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00f23c",
  null
  
)

export default component.exports